import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, onBeforeMount, ref } from "vue";
import d from "debug";
import { HeadBaseApiModel } from "../../api-models";
import { Kind, FillOptions } from "./head-models";
import Head from "./gyre-head.vue";
import useHeadModel from "./useHeadModel";


export default /*#__PURE__*/_defineComponent({
  __name: 'head-from-model',
  props: {
    headId: { default: null },
    kind: {},
    showTooltips: { type: Boolean, default: true },
    animateEntrance: { type: Boolean, default: false },
    fillOverride: { default: null },
    containerForTooltips: { default: "body" },
    whiteBackground: { type: Boolean, default: false }
  },
  emits: ["onDataLoaded"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const debug = d("cs.HeadFromModel");

const props = __props;

const emit = __emit;

// template refs
const head = ref<InstanceType<typeof Head> | null>(null);

const headModel = ref<HeadBaseApiModel | null>(null);

const readyToAnimate = ref(false);

const {
  getSoloHeadModel,
  getViewpointsHeadModel,
  getTeamSoloHeadModel,
  getTeamViewpointsHeadModel,
  getOrgSoloHeadModel,
  getOrgViewpointsHeadModel,
  getTeamEffectivenessIndividualHeadModel,
  getTeamEffectivenessAggregateHeadModel,
} = useHeadModel();

// this is so cms-session can trigger head entrance animation during a session
function playAnimation(areReversing: boolean): void {
  debug("PLAYHEADANIMATION!!!", areReversing);
  if (head.value && !areReversing) {
    head.value.playEntranceAnimationForSessions();
  }
}

function emitDataLoaded(hasData: boolean): void {
  setTimeout(() => {
    emit("onDataLoaded", hasData);
    if (props.animateEntrance) {
      readyToAnimate.value = true;
    }
  }, 0);
}

const sharedCode = computed(() => {
  return new URL(window.location.href).searchParams.get("sharedcode") ?? undefined;
});

function getHeadModelData(): void {
  let modelPromise: Promise<HeadBaseApiModel | null>;
  if (!props.headId) return;

  switch (props.kind) {
    case "solo":
      modelPromise = getSoloHeadModel(props.headId);
      break;
    case "viewpoints":
      modelPromise = getViewpointsHeadModel(props.headId);
      break;
    case "teamsolo":
      modelPromise = getTeamSoloHeadModel(props.headId);
      break;
    case "teamviewpoints":
      modelPromise = getTeamViewpointsHeadModel(props.headId);
      break;
    case "orgsolo":
      modelPromise = getOrgSoloHeadModel(props.headId);
      break;
    case "orgviewpoints":
      modelPromise = getOrgViewpointsHeadModel(props.headId);
      break;
    case "TeamEffectivenessAggregateDiamond":
      modelPromise = getTeamEffectivenessAggregateHeadModel(props.headId, sharedCode.value);
      break;
    case "TeamEffectivenessIndividualDiamond":
      modelPromise = getTeamEffectivenessIndividualHeadModel(props.headId);
      break;
    default:
      throw new Error(`Unexpected remote head kind: ${props.kind}`);
  }

  modelPromise.then((model) => {
    headModel.value = model;
    emitDataLoaded(!!headModel.value?.values);
  });
}

onBeforeMount(() => {
  getHeadModelData();
});

__expose({
  getHeadModelData,
  playAnimation,
});

return (_ctx: any,_cache: any) => {
  return (!!headModel.value)
    ? (_openBlock(), _createBlock(Head, _mergeProps({ key: 0 }, _ctx.$attrs, {
        ref_key: "head",
        ref: head,
        kind: _ctx.kind,
        values: headModel.value.values,
        valueType: headModel.value.valueType,
        showTooltips: _ctx.showTooltips,
        animateEntrance: readyToAnimate.value,
        fillOverride: _ctx.fillOverride,
        containerForTooltips: _ctx.containerForTooltips,
        whiteBackground: _ctx.whiteBackground
      }), null, 16, ["kind", "values", "valueType", "showTooltips", "animateEntrance", "fillOverride", "containerForTooltips", "whiteBackground"]))
    : _createCommentVNode("", true)
}
}

})